import { secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.main};
  padding: 3rem 1.2rem;
  border-radius: 1rem;
  text-align: center;
  position: relative;
  max-width: 39.5rem;
  background: radial-gradient(96.48% 145.93% at 96.48% 103.66%, rgba(11, 86, 63, 1) 0%, #151c2b 55.58%, #151c2b 100%),
    ${secondaryColors.offBlack};
`;

export const StyledTitle = styled.p`
  color: ${({ theme }) => theme.colors.text.main};
  font-family: ${({ theme }) => theme.fonts.familyUbuntu};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  font-size: 2.4rem;
  line-height: 3.2rem;
  margin-bottom: 1.4rem;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  sup {
    font-size: ${({ theme }) => theme.fonts.sizes.small};
  }
`;

export const StyledTimerMessage = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin-bottom: 1.1rem;
`;
